import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';

const AppNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close on ESC key when mobile menu is open
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && mobileMenuOpen) closeMobileMenu();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Lock scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [mobileMenuOpen]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} role="navigation" aria-label="Principal">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" onClick={closeMobileMenu}>
          Tratty
        </Link>

        <div id="mobile-menu" className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`} aria-hidden={!mobileMenuOpen}>
          <Link to="/" className="navbar-link" onClick={closeMobileMenu}>
            Home
          </Link>
          <Link to="/produtos" className="navbar-link" onClick={closeMobileMenu}>
            Produtos
          </Link>
          {/* Carrinho/Checkout removidos do navbar em favor do botão flutuante */}
          <Link to="/sobre" className="navbar-link" onClick={closeMobileMenu}>
            Sobre
          </Link>
          <Link to="/contato" className="navbar-link" onClick={closeMobileMenu}>
            Contato
          </Link>
        </div>

        <button
          className={`navbar-toggle ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Abrir menu"
          aria-controls="mobile-menu"
          aria-expanded={mobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      {mobileMenuOpen && <div className="navbar-backdrop" onClick={closeMobileMenu} aria-hidden="true" />}
    </nav>
  );
};

export default AppNavbar;
